// List of reserved tags for QUESTIONS used to enable different functionality

export const INTRO = "intro"; // Mark question as Intro page
export const PROFILE = "profile"; // Mark question as Profile page
export const PROFILE_1 = "profile1"; // Mark question as Profile page
export const PROFILE_2 = "profile2"; // Mark question as Profile page
export const EMAIL = "email"; // Mark question as Email page
export const GUIDED_SELLING_QUESTION1 = "gs1"; // Guided selling question 1
export const GUIDED_SELLING_QUESTION2 = "gs2"; // Guided selling question 2
export const GUIDED_SELLING_QUESTION3 = "gs3"; // Guided selling question 3
export const NEXT_COACH = "nextCoach"; // Question to move to if user is interested in coaching.
export const WITH_GDPR = "withGdpr"; // Show GDPR message on profile page
export const LESS_THAN_25LBS = "<25lbs"; // Weight result page
export const MORE_THAN_25LBS = ">25lbs"; // Weight result page
export const MORE_THAN_50LBS = ">50lbs"; // Weight result page
export const COACHING_STYLE = "coachingStyle"; // Marks question as Coach preference question.
export const COACHING_STYLE_SECOND = "coachingStyleSecond"; // Marks question as Coach preference question in Diabetes branch for uni2.
export const BMI_MESSAGE = "bmiMessage"; // Page to show BMI message on
export const BMI_MESSAGE_CURRENT_WEIGHT = "bmiMessageCurrentWeight"; // Page to show BMI Current Weight message on
export const IMG_WIDTH_100_PERC = "imgWidth100Perc"; // To make image to have 100% width.
export const NO_PROGRESS_BAR = "noProgressBar"; // Disable progress bar on question page
export const MULTI_CHOICE_GROUPS = "multiChoiceGroups"; // Makes question to be multi-choice groups question, e.g. like Cuisine & Meal.
export const RECIPE_FILTER_RESULTS = "recipeFilterResults"; // Makes question to be recipe filter results page.
export const DIETARY = "dietary"; // Marks quesiton with dietary preferences.
export const WHY_LOSE_WEIGHT = "whyLoseWeight"; // Why lose weight section on Results page
export const NOT_COUNT_IN_PROGRESS_BAR = "notCountProgressBar"; // Not count question in progress bar progress.
export const IS_MALE = "isMale"; // Skip female-related questions if gender is male.
export const NEXT_MALE = "nextMale"; // Question to move to if gender is male.
export const ANSWER_OPTIONAL = "answerOptional"; // Makes answering the question optional. Sets the answer to the last option if not answered.
// Eligibility tags:
export const WEIGHT_HAS_EXCEEDED_LIMIT = "weightHasExceededLimit"; // If the user's weight exceeded limit BMI = 27
export const PAST_WEIGHT_LOSS_MEDICATION = "pastWeightLossMedication"; // Marks question whether user took weight loss medication before.
export const PAST_ED_DIAGNOSIS = "pastEdDiagnosis"; // Marks the question whether user has ever had eating disorders.
export const BREASTFEEDING = "breastfeeding"; // Marks the question whether user is breastfeeding.
export const PREGNANCY = "pregnancy"; // Marks the question whether user is pregnant.
export const PAST_DIAGNOSIS = "pastDiagnosis"; // Marks the question about what ilnesses user has.
export const BMI_27_CHECK = "bmi27Check"; // BMI 27 check.
export const SHOW_IF_BMI_LESS_27 = "showIfBmiLess27"; // Show weight question if BMI <= 27.
export const SHOW_IF_BMI_MORE_30 = "showIfBmiMore30"; // Question to show if BMI > 30.
export const SHOW_IF_BMI_BETWEEN_27_AND_30 = "showIfBmiBetween27And30"; // Question to show if BMI between 27 and 30.
// Longer Eligibility tags:

// Tags for endpoint
export const ALLERGIC_REACTION = "allergicReaction";
export const BLOOD_PRESSURE_CHECK = "bloodPressureCheck";
export const PAST_DIAGNOSIS2 = "pastDiagnosis2"; // this one is for branching as well.
export const STRUGGLES = "struggles";
export const PAST_WEIGHT_LOSS_METHODS = "pastWeightLossMethods";
export const PAST_DIETS = "pastDiets";
export const PARENTS_CONDITIONS = "parentsConditions";
export const ALCOHOL_CONSUMPTION = "alcoholConsumption";
export const MEDICATIONS = "medications";
export const OPIOID_FREQUENCY = "opioidFrequency";
export const ALLERGIC_REACTIONS_MEDICATIONS = "allergicReactionMedications";

// PHQ1-9 and suicide-1, suicide-1a - mental health questions.
export const PHQ1 = "PHQ-1";
export const PHQ2 = "PHQ-2";
export const PHQ3 = "PHQ-3";
export const PHQ4 = "PHQ-4";
export const PHQ5 = "PHQ-5";
export const PHQ6 = "PHQ-6";
export const PHQ7 = "PHQ-7";
export const PHQ8 = "PHQ-8";
export const PHQ9 = "PHQ-9";
export const PHQ9B = "PHQ-9b";
export const SUICIDE1 = "suicide-1";
export const SUICIDE1A = "suicide-1a";
export const DIETING = "dieting"; // question which asks whether use tried dieting.
export const PANCREATITIS_GALLBLADDER = "pancreatitisGallbladder"; // question about pancreatitis and gallbladder.
export const PANCREATITIS_BRANCH_END = "pancreatitisBranchEnd"; // end of branch when pancreatitis selected
export const SWITCH_HEADERS = "switchHeaders"; // Switch header text 1 and 2 on a question.

// Join sequence tags
export const ACCOUNT_CREATION = "accountCreation"; // Mark question as Account Creation page
export const ADDRESS_UPDATE = "addressUpdate"; // Mark question as Address Update page
export const PHONE_NUMBER_UPDATE = "phoneNumberUpdate"; // Mark question as Phone Update page
export const REGION_UPDATE = "regionUpdate"; // Mark question as Region Update page
export const ALCOHOL_FEMALE = "alcoholFemale"; // Mark question as alcohol female page
export const ALCOHOL_NOT_FEMALE = "alcoholNotFemale"; // Mark question as alcohol not female page

// Unified quiz tags
export const PRODUCT_BRANCHING = "productBranching"; // Marks question as product branching question - the point we decide what 1 of 4 products to recommend
export const START_CLINICAL_BRANCH = "startClinicalBranch"; // Marks question as the start of clinical branch
export const END_CLINICAL_BRANCH = "endClinicalBranch"; // Marks question as the start of clinical branch
export const START_POINTS_BRANCH = "startPointsBranch"; // Marks question as the start of points branch
export const END_POINTS_BRANCH = "endPointsBranch"; // Marks question as the start of points branch
export const START_POINTS_WORKSHOP_BRANCH = "startPointsWorkshopBranch"; // Marks question as the start of points + workshop branch
export const START_DIABETES_BRANCH = "startDiabetesBranch"; // Marks question as the start of diabetes branch
export const END_DIABETES_BRANCH = "endDiabetesBranch"; // Marks question as the start of diabetes branch
export const START_DIABETES_WORKSHOP_BRANCH = "startDiabetesWorkshopBranch"; // Marks question as the start of diabetes + workshop branch
export const END_GLP1_BRANCH = "endGlp1Branch"; // Marks question as the end of GLP1 branch
export const US_STATE = "usState"; // Marks question to select US state
export const NEXT_WORKSHOP_INFO_POINTS = "nextWorkshopInfoPoints"; // Marks question to show workshop info page in Points branch.
export const WORKSHOP_INFO_POINTS = "workshopInfoPoints"; // Marks question as Workshop info page for Points branch.
export const NEXT_WORKSHOP_INFO_DIABETES = "nextWorkshopInfoDiabetes"; // Marks question to show workshop info page in Diabetes branch.
export const WORKSHOP_INFO_DIABETES = "workshopInfoDiabetes"; // Marks question as Workshop info page for Diabetes branch.
export const GALLBLADDER_BRANCH_END = "gallbladderBranchEnd"; // Marks question as the end of gallbladder branch
export const DIABETES_TESTIMONIAL = "diabetesTestimonial"; // Marks question with diabetes testimonial at the end of pancreatitis/gallbladder branch
export const FOOTER_TEXT_UNDER_CTA = "footerTextUnderCta"; // Marks question with footer text under CTA
export const DOUBLE_NEXT_BUTTON = "doubleNextButton"; // Marks question with double next button.
export const HIDE_NEXT_IF_BMI_LESS_27 = "hideNextIfBmiLess27"; // Hide next question if BMI < 27.
export const SHOW_NEXT_IF_BMI_LESS_27 = "showNextIfBmiLess27"; // Next question to show if BMI < 27.
export const SHOW_NEXT_IF_BMI_GREATER_27 = "showNextIfBmiGreater27"; // Show next question if BMI >= 27.
export const SHOW_IF_BMI_GREATER_27 = "showIfBmiGreater27"; // Show question if BMI >= 27.

// Unified Quiz V3 & V4 tags
export const CLINICAL_BRANCHING = "clinicalBranching"; // Marks question as clinical branching question - decide whether to go into clinical
export const ELIGIBILITY_BRANCHING = "eligibilityBranching"; // Marks question as eligibility branching question - decide whether to go into short eligibility
export const START_SHORT_BEHAVIORAL_BRANCH = "startShortBehavioralBranch"; // Marks question as the start of short behavioral branch

// Obsolete, to remove later once removed from Admin UI (otherwise sections number for progress bar is not calculated properly).
export const OATMILK_BG = "oatMilkBg"; // Mark page to have oatmilk background.

// Longer Eligibility tags:
export const DIETING_ANSWER = "dieting"; // Mark answer dieting to show Diets question
export const OPIOID = "opioid"; // Mark answer opiod medication to show Opioids question
export const PANCREATITIS = "pancreatitis"; // Mark answer to show pancreatitis questions
export const GALLBLADDER = "gallbladder"; // Mark gallbladder to show gallbladder questions

export const ALL_SYSTEM_TAGS = [
  INTRO,
  PROFILE,
  PROFILE_1,
  PROFILE_2,
  EMAIL,
  GUIDED_SELLING_QUESTION1,
  GUIDED_SELLING_QUESTION2,
  GUIDED_SELLING_QUESTION3,
  NEXT_COACH,
  WITH_GDPR,
  LESS_THAN_25LBS,
  MORE_THAN_25LBS,
  MORE_THAN_50LBS,
  COACHING_STYLE,
  COACHING_STYLE_SECOND,
  BMI_MESSAGE,
  BMI_MESSAGE_CURRENT_WEIGHT,
  NO_PROGRESS_BAR,
  IMG_WIDTH_100_PERC,
  MULTI_CHOICE_GROUPS,
  RECIPE_FILTER_RESULTS,
  DIETARY,
  WHY_LOSE_WEIGHT,
  NOT_COUNT_IN_PROGRESS_BAR,
  IS_MALE,
  NEXT_MALE,
  ANSWER_OPTIONAL,
  WEIGHT_HAS_EXCEEDED_LIMIT,
  PAST_WEIGHT_LOSS_MEDICATION,
  PAST_ED_DIAGNOSIS,
  PREGNANCY,
  BREASTFEEDING,
  PAST_DIAGNOSIS,
  BMI_27_CHECK,
  SHOW_NEXT_IF_BMI_LESS_27,
  HIDE_NEXT_IF_BMI_LESS_27,
  SHOW_NEXT_IF_BMI_GREATER_27,
  SHOW_IF_BMI_BETWEEN_27_AND_30,
  SHOW_IF_BMI_GREATER_27,
  SHOW_IF_BMI_LESS_27,
  SHOW_IF_BMI_MORE_30,
  PHQ1,
  PHQ2,
  PHQ3,
  PHQ4,
  PHQ5,
  PHQ6,
  PHQ7,
  PHQ8,
  PHQ9,
  PHQ9B,
  SUICIDE1,
  SUICIDE1A,
  DIETING,
  PANCREATITIS_GALLBLADDER,
  PANCREATITIS_BRANCH_END,
  SWITCH_HEADERS,
  ALLERGIC_REACTION,
  BLOOD_PRESSURE_CHECK,
  PAST_DIAGNOSIS2,
  STRUGGLES,
  PAST_WEIGHT_LOSS_METHODS,
  PAST_DIETS,
  PARENTS_CONDITIONS,
  ALCOHOL_CONSUMPTION,
  MEDICATIONS,
  OPIOID_FREQUENCY,
  ALLERGIC_REACTIONS_MEDICATIONS,
  ACCOUNT_CREATION,
  ADDRESS_UPDATE,
  PHONE_NUMBER_UPDATE,
  REGION_UPDATE,
  ALCOHOL_FEMALE,
  ALCOHOL_NOT_FEMALE,
  PRODUCT_BRANCHING,
  START_CLINICAL_BRANCH,
  START_POINTS_BRANCH,
  START_POINTS_WORKSHOP_BRANCH,
  START_DIABETES_BRANCH,
  START_DIABETES_WORKSHOP_BRANCH,
  US_STATE,
  NEXT_WORKSHOP_INFO_POINTS,
  WORKSHOP_INFO_POINTS,
  NEXT_WORKSHOP_INFO_DIABETES,
  WORKSHOP_INFO_DIABETES,
  GALLBLADDER_BRANCH_END,
  DIABETES_TESTIMONIAL,
  END_POINTS_BRANCH,
  END_DIABETES_BRANCH,
  END_GLP1_BRANCH,
  END_CLINICAL_BRANCH,
  FOOTER_TEXT_UNDER_CTA,
  OATMILK_BG,
  DOUBLE_NEXT_BUTTON,
  CLINICAL_BRANCHING,
  ELIGIBILITY_BRANCHING,
  START_SHORT_BEHAVIORAL_BRANCH,
  GALLBLADDER
];

// List of reserved tags for ANSWERS
export const MULTISELECT_NONE_OF_THESE = "noneOfThese"; // Mark answer as none of other answers. Applies for multi-choice questions.
// Eligibility tags:
export const DIABETIC_TYPE_1 = "diabeticType1"; // Mark answer diabetes type 1
export const CURRENTLY_PREGNANT = "currentlyPregnant"; // Marks the answer if currently pregnant.

// Unified quiz tags
export const DIABETIC_TYPE_2 = "diabeticType2"; // Mark answer diabetes type 2
export const SKIP_ANSWER = "skip"; // Mark "skip" answer on start of clinical branch.
